import { OtmBankAllowedData } from '../../../../redux-store/types/newPurchase';
import { IsAllow } from '../../../../redux-store/types/portfolio';
import { Bank_New } from '../ExploreMFs/types';
import * as yup from 'yup';

export type Bank = Omit<Bank_New, 'name'> & {
    accountHolder: string;
    confirmAccountNumber: string;
    bankName: Omit<OtmBankAllowedData, 'rtaCode'>;
};
export interface InitStateType extends Bank {
    name: string;
    email: string;
    mobile: string;
    pan: string;
    amount: string;
    frequency: string;
    toDate: Date | string;
    fromDate: Date | string;
    allowedBanks: OtmBankAllowedData[];
    untilCancelled: IsAllow;
    rtaCode: null | RTA_CODES;
    declaration: boolean;
}

export enum EMandatePaths {
    OtmDetails = '/emandate',
    OtmRegister = '/otm-register',
    OtmStatus = '/otm-status',
    OtmCancelOTP = '/otm-verify-otp',
    OtmCancelStatus = '/otm-cancel-status'
}

export enum RTA_CODES {
    CAMS = 'CAMS',
    KFIN = 'KFIN',
}

export type MandateDetails = {
    amount: string;
    startDate: string;
    endDate: string;
    frequency: string;
    untilCancelled: IsAllow;
    debitType: 'M';
    category: 'M001';
    otmType: 'EOTM';
};
export type RegisterOtmReqType = {
    bank: Omit<Bank_New, 'neftIfsc' | 'pincode' | 'bankDefault'> & {
        holderName: string;
        neftIfscCode: string;
    };
    mandateDetails: MandateDetails;
    source: 'MFC';
    amc: string;
    rtaCode: RTA_CODES;
    otmMobile: string;
    otmEmail: string;
    investorName: string;
};

type OtmFormCheckFields = Omit<
    InitStateType,
    | 'pan'
    | 'frequency'
    | 'accountType'
    | 'bankDefault'
    | 'city'
    | 'pincode'
    | 'micr'
    | 'neftIfsc'
    | 'allowedBanks'
    | 'untilCancelled'
    | 'rtaCode'
    | 'declaration'
>;
export type OtmSchemaFields = yup.SchemaOf<OtmFormCheckFields>;

export type ExtraValidationsType = {
    bankName?: {
        bankName: string;
    } | null;
    accountNoHint?: string;
};

export type OTMCancelRequestType = {
    data: [
        {
            amc?: string;
            rtaName: RTA_CODES,
            omUmrn: string;
            mandateRefId: string;
            maxAmount: string;
            otmType: string;
            payoutMech: string;
            itemNo: string;
        },
    ];
}
